import _ from 'lodash';
import React from 'react';
import { StatusItem } from '../../../api';
import { formatDate } from '../../../services/primitives/date-utils';
import { getStatusCategoryCode, getStatusCode } from '../../../services';
import { renderAmount } from '../../data-table';
import * as S from './status.styles';

export const StatusItemsDetails: React.FunctionComponent<{ items: StatusItem[] }> = React.memo(({ items }) => {
    return (
        <div>
            {items.map(item => {
                const dos = _.compact([item.fromDateOfService, item.throughDateOfService]).map(d => formatDate(d, 'MM/dd/yyyy')).join(' - ');

                const modifiers = _.compact([
                    item.modifierCode1,
                    item.modifierCode2,
                    item.modifierCode3,
                    item.modifierCode4,
                ]).join(', ');

                return (
                    <S.GroupItemContainer>
                        <S.ItemHeader>
                            {!_.isEmpty(dos) && (
                                <S.LabelRowVertical>
                                    <S.Label>Dates of Service</S.Label> <S.Value>{dos}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            {item.procedureCode && (
                                <S.LabelRowVertical>
                                    <S.Label>Procedure Code</S.Label> <S.Value>{item.procedureCode}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            {!_.isEmpty(modifiers) && (
                                <S.LabelRowVertical>
                                    <S.Label>Modifiers</S.Label> <S.Value>{modifiers}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            <S.LabelRowVertical>
                                <S.Label>Quantity</S.Label> <S.Value>{item.paidUnits || 0}</S.Value>
                            </S.LabelRowVertical>
                            {item.chargeAmount && (
                                <S.LabelRowVertical>
                                    <S.Label>Billed</S.Label> <S.Value>{renderAmount(item.chargeAmount)}</S.Value>
                                </S.LabelRowVertical>
                            )}
                            {item.paidAmount && (
                                <S.LabelRowVertical>
                                    <S.Label>Paid</S.Label> <S.Value>{renderAmount(item.paidAmount)}</S.Value>
                                </S.LabelRowVertical>
                            )}
                        </S.ItemHeader>
                        {(item.details || []).map((detail, i) => {
                            return (
                                <S.DetailContainer key={i}>
                                    {detail.effectiveDate && (
                                        <S.GroupItemTitle>
                                            Status as of {formatDate(detail.effectiveDate, 'MM/dd/yyyy')}
                                        </S.GroupItemTitle>
                                    )}
                                    <S.DetailsList>
                                        {detail.categoryCode1 && (
                                            <li>
                                                <S.MessageItem>
                                                    {getStatusCategoryCode(detail.categoryCode1)}
                                                </S.MessageItem>
                                            </li>
                                        )}
                                        {detail.statusCode1 && (
                                            <li>
                                                <S.MessageItem>{getStatusCode(detail.statusCode1)}</S.MessageItem>
                                            </li>
                                        )}
                                        {detail.categoryCode2 && (
                                            <li>
                                                <S.MessageItem>
                                                    {getStatusCategoryCode(detail.categoryCode2)}
                                                </S.MessageItem>
                                            </li>
                                        )}
                                        {detail.statusCode2 && (
                                            <li>
                                                <S.MessageItem>{getStatusCode(detail.statusCode2)}</S.MessageItem>
                                            </li>
                                        )}
                                        {detail.categoryCode3 && (
                                            <li>
                                                <S.MessageItem>
                                                    {getStatusCategoryCode(detail.categoryCode3)}
                                                </S.MessageItem>
                                            </li>
                                        )}
                                        {detail.statusCode3 && (
                                            <li>
                                                <S.MessageItem>{getStatusCode(detail.statusCode3)}</S.MessageItem>
                                            </li>
                                        )}
                                    </S.DetailsList>
                                </S.DetailContainer>
                            );
                        })}
                    </S.GroupItemContainer>
                );
            })}
        </div>
    );
});
